import { People as PeopleIcon } from '@mui/icons-material'
import { Checkbox, Grid2 as Grid, ListItemText, MenuItem, Paper, Select, Switch, Typography } from '@mui/material'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getRequestConfig, getToken } from '../auth/auth'
import FormViewCommandBar from '../commandBar/FormViewCommandBar'
import { ApiGateway } from '../config/config'
import Page from '../layout/Page'
import { TextField } from '../layout/TextField'
import { handleCheckboxChange, handleFieldChange, handleSelectChange } from '../form/Form.js'

import bus from '../utils/EventBus.js';
import Event from '../utils/EventNames.js';

export default function UserFormPage(props = {}) {
  const textFieldRefs = useRef([]);
  const params = useParams()
  const navigate = useNavigate()

  const defaultUser = {
    koId: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [],
    isActive: true
  }

  // const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const [initialized, setInitialized] = useState(false)
  const [isNewUser, _setIsNewUser] = useState(params.koId === 'new')
  const [_appUserFound, setAppUserFound] = useState(false)
  const [user, setUser] = useState(defaultUser)


  const availableRoles = [{
    id: 4,
    name: 'SRA Admin'
  }, {
    id: 5,
    name: 'SRA User'
  }, {
    id: 14,
    name: 'LDS Viewer'
  }]
  const availableRoleIds = [4, 5, 14]

  
  
  const getUserByKoId = async (koId, requestConfig) => {
    if (!requestConfig) {
      requestConfig = await getRequestConfig()
    }
    const basePath = `${ApiGateway.employee}/${koId}`
    setIsLoading(true)
    try {
      const response = await axios.get(basePath, requestConfig)
      if (response.data) {
        let _user = response.data
        _user.roles = _user.roles.filter(r => availableRoleIds.includes(r.id)).map(r => r.id)
        console.log('_user: ', _user)
        setUser(_user)
        return _user
      } else {
        setAppUserFound(false)
      }
    } catch (error) {
      setAppUserFound(false)
    } finally {
      setIsLoading(false)
    }
  }

  const saveUser = async () => {
    const basePath = `${ApiGateway.employee}/${user.koId}/sra`
    let isValid = textFieldRefs.current.reduce((isValid, ref) => {
      return isValid && ref.validate()
    }, true);
    if(isValid) {
      try {
        setIsSaving(true)
        let _user = structuredClone(user)
        // if(isNewUser) {
        //   _user.effectiveDate = 
        // }
        if(_user.roles?.length) {
          _user.roles = _user.roles.map(r => { return {id: r}})
        }
        const requestConfig = await getRequestConfig()
        await axios.post(basePath, _user, requestConfig)
        setIsSaving(false)
        bus.emit(Event.ALERT, {text: 'Saved Successfully!', style: 'success', duration: 2000})
      } catch (error) {
        console.log('saverUser ERROR: ', error)
        setIsSaving(false)
        bus.emit(Event.ALERT, {text: `Error saving user: ${error.message}`, style: 'error'})
      }
    } else {
      bus.emit(Event.ALERT, {text: 'Please address the errors before proceeding!', style: 'warning', duration: 3000})
    }
  }

  const onSave = async () => {

    await saveUser()
    setDirty(false)
  }

  const setDirty = (dirty = true) => {
    setIsDirty(dirty)
  }

  const getBreadcrumb = () => {
    return (
      <span>
        <PeopleIcon/>
        &nbsp;{ isNewUser ? <>Add&nbsp;New</> : <>Edit</> }&nbsp; User
      </span>
    )
  }

  const initializePage = async () => {
    if (params.koId && params.koId !== 'new' && !initialized) {
      const requestConfig = await getRequestConfig()
      setIsLoading(true)
      await getUserByKoId(params.koId, requestConfig)
      setInitialized(true)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    initializePage()
  }, [])

  
  return (
    
    <Page {...props} breadcrumb={getBreadcrumb()} isLoading={isLoading} isSaving={isSaving}
      commandBar={<FormViewCommandBar onSave={onSave} enableSave={isDirty && !isSaving} showCancel={false} showClose={false} />}>
      
      <Paper sx={{ padding: 2, width: '800px' }}>
        <Grid container >
          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>KO ID:</Typography>
          </Grid>
          <Grid size={8} sx={{marginBottom:'.5em' }}>
            <TextField 
              ref={(el) => (textFieldRefs.current[0] = el)}
              required
              value={user.koId} 
              onChange={(e) => handleFieldChange('koId', e.target?.value, user, setUser, setDirty)} 
              variant="outlined" 
              fullWidth />
          </Grid>
          
        
          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>First Name:</Typography>
          </Grid>
          <Grid size={8} sx={{marginBottom:'.5em' }}>
            <TextField 
              ref={(el) => (textFieldRefs.current[1] = el)}
              required 
              value={user.firstName} 
              onChange={(e) => handleFieldChange('firstName', e.target?.value, user, setUser, setDirty)}
              variant="outlined"
              fullWidth />
          </Grid>
        
          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>Last Name:</Typography>
          </Grid>
          <Grid size={8} sx={{marginBottom:'.5em' }}>
            <TextField ref={(el) => (textFieldRefs.current[2] = el)}
              required 
              value={user.lastName} 
              onChange={(e) => handleFieldChange('lastName', e.target?.value, user, setUser, setDirty)}
              variant="outlined"
              fullWidth />
          </Grid>
        
          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>Email:</Typography>
          </Grid>
          <Grid size={8} sx={{marginBottom:'.5em' }}>
            <TextField 
              ref={(el) => (textFieldRefs.current[3] = el)}
              required
              email
              value={user.email}
              onChange={(e) => handleFieldChange('email', e.target?.value, user, setUser, setDirty)}
              variant="outlined"
              fullWidth />
          </Grid>
        
          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>Roles:</Typography>
          </Grid>
          <Grid size={8} sx={{marginBottom:'.5em' }}>
            <Select
              id="roles"
              multiple
              value={user.roles}
              onChange={(e) => handleSelectChange('roles', e, user, setUser, setDirty)}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                keepMounted: true, 
                disableAutoFocusItem: true, 
                disablePortal: true,
              }}
              renderValue={(selected) => 
                selected.map((selectedId) => {
                  const role = availableRoles.find(r => r.id === selectedId);
                  return role ? role.name : '';
                }).join(', ')
              }
            >
              {availableRoles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  <Checkbox checked={user.roles.includes(role.id)} />
                  <ListItemText primary={role.name} />
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ marginTop: '1em', textAlign:'right', marginRight: '1em' }}>{ user.isActive ? 'Active:' : 'Inactive:'}</Typography>
          </Grid>
          <Grid size={8}>
            <Switch
              checked={user.isActive}
              onChange={(event) => handleCheckboxChange('isActive', event, user, setUser, setDirty)}
              name="isActive"
              color="primary"
            />
          </Grid>
        </Grid>
      </Paper>
    </Page>
  )
}